import { TypedOption } from "api/common/types/common.types";
import { valueof } from "api/common/utils/type.utils";
import { QuestionWithOptions } from "components/Forms/types/questions.types";

import { ProficiencyFeedbackFormField } from "../../../ProficiencyFeedbackForm.schema";

const QUALITY_RATINGS = {
  POOR: "Poor",
  SUFFICIENT: "Sufficient",
  EXCELLENT: "Excellent",
} as const;

type QualityRating = valueof<typeof QUALITY_RATINGS>;

const QUALITY_RATING_OPTIONS: TypedOption<QualityRating>[] = [
  { label: "Poor", value: QUALITY_RATINGS.POOR },
  { label: "Sufficient", value: QUALITY_RATINGS.SUFFICIENT },
  { label: "Excellent", value: QUALITY_RATINGS.EXCELLENT },
];

const SEVERITY_RATINGS = {
  NONE: "None",
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
  EXCESSIVE: "Excessive",
} as const;

type SeverityRating = valueof<typeof SEVERITY_RATINGS>;

const SEVERITY_RATING_OPTIONS: TypedOption<SeverityRating>[] = [
  { label: "None", value: SEVERITY_RATINGS.NONE },
  { label: "Low", value: SEVERITY_RATINGS.LOW },
  { label: "Medium", value: SEVERITY_RATINGS.MEDIUM },
  { label: "High", value: SEVERITY_RATINGS.HIGH },
  { label: "Excessive", value: SEVERITY_RATINGS.EXCESSIVE },
];

// Rating questions mapped to form fields
const PF_FORM_RATING_QUESTIONS: readonly QuestionWithOptions<
  ProficiencyFeedbackFormField,
  SeverityRating | QualityRating
>[] = [
  {
    label: "Quality of package (English, technical):",
    value: "quality",
    options: QUALITY_RATING_OPTIONS,
  },
  {
    label: "Number of Discrepancies/Inconsistences between documentation:",
    value: "discrepancies",
    options: SEVERITY_RATING_OPTIONS,
  },
  {
    label: "Incomplete Evidence and/or Incorrect Test Performance:",
    value: "evidence",
    options: SEVERITY_RATING_OPTIONS,
  },
  {
    label: "Clarification Required:",
    value: "clarification",
    options: SEVERITY_RATING_OPTIONS,
  },
  {
    label: "Missing Items in Documentation (AGD, TSS, others?):",
    value: "missingItems",
    options: SEVERITY_RATING_OPTIONS,
  },
] as const;

export {
  QUALITY_RATINGS,
  SEVERITY_RATINGS,
  QUALITY_RATING_OPTIONS,
  SEVERITY_RATING_OPTIONS,
  PF_FORM_RATING_QUESTIONS,
};
export type { QualityRating, SeverityRating };
